export type ThemeBrightness = 'light' | 'dark';
export enum ThemeBrightnessEnum {
  'Light' = 'light',
  'Dark' = 'dark',
}
